<template>
    <div v-if="visible">
        <!-- pc版本的fixed bottom bar -->
        <transition name="toolbarTransition">
            <div
                v-if="fixedBottomShow"
                ref="refBottombarPC"
                class="w-full hidden md:block fixed left-0 bottom-0 z-[55]"
            >
                <div class="w-full xl:container mx-auto px-3 xs:px-5 xl:px-3 ">
                    <div class="min-h-[4.25rem] bg-black md:bg-gray-900 flex items-center justify-between px-3 md:px-4 rounded-t">
                        <!-- pc才有 -->
                        <div class="w-full absolute left-0 text-center text-amber-500 pointer-events-none">
                            <slot name="center" />
                        </div>
                        <!-- 左邊按鈕 -->
                        <div>
                            <slot name="left" />
                        </div>
                        <!-- 右邊按鈕 -->
                        <div class="bottombar-action flex items-center justify-between">
                            <slot name="right" />
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <!-- 手機版的bottom bar ＆ 電腦版固定bottom bar -->
        <div
            ref="refBottombar"
            class="fixed inset-x-0 bottom-0 w-full md:relative md:my-4 md:rounded overflow-hidden z-[55] md:z-[45]"
        >
            <div class="bg-[rgba(0,0,0,0.5)] px-4 md:px-5 flex justify-between items-baseline text-white md:hidden">
                <slot name="top">
                    <!-- <span class="text-xs">預估轉出總金額(新台幣)：</span>
                    <span class="text-base xs:text-lg">0</span> -->
                </slot>
            </div>
            <!-- 基本 -->
            <div class="h-[4.25rem] bg-black md:bg-gray-900 flex items-center justify-between px-3 xs:px-4 flex-wrap relative">
                <!-- pc才有 -->
                <div class="w-full absolute left-0 text-center text-amber-500 hidden md:block pointer-events-none">
                    <slot name="center" />
                </div>
                <!-- 左邊按鈕 -->
                <div>
                    <slot name="left" />
                </div>
                <!-- 右邊按鈕 -->
                <div class="bottombar-action flex items-center justify-between">
                    <slot name="right" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import { ref, onMounted, onUnmounted, nextTick, watch, watchEffect } from 'vue';
import { ref, onMounted, nextTick, watch, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useEventListener, useResizeObserver } from '@vueuse/core';
const useResize = (props) => {
    const store = useStore();
    const refBottombar = ref(null);
    const elementHeight = ref(0);
    const fixedBottomShow = ref(false);
    const route = useRoute();
    const visible = ref(true);
    const isWidthOver780 = ref(window.innerWidth > 780);
    const onResize = () => {
        setTimeout(() => {
            if (refBottombar.value) {
                // 手機版本 tool bar 高度
                elementHeight.value = refBottombar.value.offsetHeight;
                store.dispatch('layout/setBottomPadding', elementHeight.value);
                const offsetTopBottom = ref(refBottombar.value.offsetTop);

                // show pc fixed toolbar 視窗高度 - element與上方距離 - element高度 + scrollＹ距離 <= 0
                fixedBottomShow.value = window.innerHeight - (offsetTopBottom.value + elementHeight.value) + window.pageYOffset <= 0;
            }
        }, 0);

        isWidthOver780.value = window.innerWidth > 780;
    };
    onMounted(() => {
        useEventListener(window, 'resize', (evt) => {
            onResize();
        });
        useResizeObserver(document.querySelector('#app'), (entries) => {
            onResize();
        });

        useEventListener(window, 'scroll', (evt) => {
            onResize();
        });
    });

    watch(() => route.path, (nV, oV) => {
        store.dispatch('layout/setBottomPadding', 0);
        nextTick(() => {
            onResize();
        });
    }, {
        immediate: true,
    });
    watchEffect(() => {
        if (isWidthOver780.value) {
            // 大於780 不要show, but selectedNum > 0 要show
            visible.value = props.controlVisible;
        } else {
            // 小於780 要show
            visible.value = true;
        }
    });

    return { refBottombar, fixedBottomShow, visible };
};

export default {
    name: 'Bottombar',
    props: {
        controlVisible: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const { refBottombar, fixedBottomShow, visible } = useResize(props);
        return { refBottombar, fixedBottomShow, visible };
    },
};
</script>
<style lang="scss" scoped>
.toolbarTransition-enter-active {
    animation: toolbar-in 0.35s;
}
.toolbarTransition-leave-active {
    animation: toolbar-in 0.35s reverse;
}
@keyframes toolbar-in {
    0% {
        transform: translateY(300%);
    }
    100% {
        transform: translateY(0);
    }
}
</style>
